import { CompetitionCard } from 'page-components'

export const CompetitionDetail = ({ data }) => {
  return (
    <>
      {
        data?.map((ele) => {
          return <CompetitionCard competition={ele} showRankBox={false} />
        })
      }
    </>
  )
}
